export const SET_FREE_COMMENT_DESCRIPTIONS =
  "answerOther/SET_FREE_COMMENT_DESCRIPTIONS";
export const SET_NEXT_PAGE = "answerOther/SET_NEXT_PAGE";
export const SET_PREV_PAGE = "answerOther/SET_PREV_PAGE";

export const setFreeCommentDescriptions = freeCommentDescriptions => ({
  type: SET_FREE_COMMENT_DESCRIPTIONS,
  freeCommentDescriptions
});

export const setNextPage = () => ({
  type: SET_NEXT_PAGE
});

export const setPrevPage = () => ({
  type: SET_PREV_PAGE
});

const initialState = {
  currentPage: 0, // 現在のページ
  freeCommentDescriptions: []
};

const answerOther = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_FREE_COMMENT_DESCRIPTIONS: {
      const { freeCommentDescriptions } = action;
      return { ...state, freeCommentDescriptions };
    }

    case SET_NEXT_PAGE: {
      return { ...state, currentPage: 1 };
    }

    case SET_PREV_PAGE: {
      return { ...state, currentPage: 0 };
    }

    default:
      return state;
  }
};

export default answerOther;



// WEBPACK FOOTER //
// ./src/redux/modules/answer/answerOther.js